import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { MatAccordion } from "@angular/material/expansion";
import { Observable, of } from "rxjs";
import { UiService } from "src/app/services/ui.service";

@Component({
  selector: "app-leitor-side-tools",
  templateUrl: "./leitor-side-tools.component.html",
  styleUrls: ["./leitor-side-tools.component.scss"],
})
export class LeitorSideToolsComponent implements OnInit {
  @ViewChild(MatAccordion) accordion: MatAccordion;
  @Input() transition = false;

  public panelindice = false;
  public paneltimer = false;
  public panelbrain = false;
  public panelcircle = false;
  public panelmessage = false;
  public paneltags = false;
  public panelplay = false;
  public openHover = true;

  public breakpointLg$: Observable<boolean> = of(false);

  constructor(public uiService: UiService) {}

  ngOnInit(): void {
    this.breakpointLg$ = this.uiService.getBreakpointLg();
  }

  public expansionLeitorSideTools(event: any) {
    event.preventDefault();
    event.stopPropagation();
    if (this.uiService.isBreakpointLg) {
      return;
    }

    if (!this.openHover) {
      this.openHover = true;
    } else {
      this.accordion.closeAll();
      this.openHover = false;
    }
  }

  public togglePanelIndice(open: boolean) {
    this.panelindice = open;
    if (!this.uiService.isBreakpointLg &&  this.panelindice) {
      this.openHover = true;
    }
  }
  public togglePanelTimer(open: boolean) {
    this.paneltimer = open;
    if (!this.uiService.isBreakpointLg && this.paneltimer ) {
      this.openHover = true;
    }
  }
  public togglePanelBrain(open: boolean) {
    this.panelbrain = open;
    if (!this.uiService.isBreakpointLg && this.panelbrain) {
      this.openHover = true;
    }
  }
}
